import StepRoomInformation from './StepRoomInformation.container';

export default StepRoomInformation;
